/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Tue, Jul 20th 2021, 11:14:33 am
 *
 * *****************************************************
 */

import { Stack } from '@shopify/polaris';
import { Helmet } from 'react-helmet';

import AuthLayout from 'features/auth/views/layouts/AuthLayout';
import Spinner from 'features/common/views/components/Spinner';

import { PageContainer } from './styles';

const Loading = () => (
  <AuthLayout>
    <Helmet>
      <title>WiseIO</title>
      <meta name="robots" content="noindex" />
    </Helmet>
    <PageContainer>
      <Stack alignment="center">
        <Spinner />
        <span>Loading ...</span>
      </Stack>
    </PageContainer>
  </AuthLayout>
);

export default Loading;
